import { render, staticRenderFns } from "./Comissoes.vue?vue&type=template&id=3da917d6"
import script from "./Comissoes.vue?vue&type=script&lang=js"
export * from "./Comissoes.vue?vue&type=script&lang=js"
import style0 from "./Comissoes.vue?vue&type=style&index=0&id=3da917d6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports